var map = {
	"./ai-page.ts": 83963,
	"./collection.ts": 54661,
	"./page.ts": 91898,
	"./plugin.ts": 95074,
	"./project-auth-appids.ts": 98987,
	"./project-ui.ts": 35147,
	"./project.ts": 26766,
	"./scf.ts": 35969,
	"./workflow.ts": 11516,
	"./xy-flow.ts": 9303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28810;